import { memo } from 'react';

import { ToolGroupEntry } from '../../extensions/tool-extension';
import { DefaultToolCallGroup } from './DefaultToolCallGroup';
import { InlineToolGroup } from './InlineToolGroup';

type ToolCallGroupProps = {
  entries: ToolGroupEntry[];
  variant?: 'default' | 'inline';
  isStreaming?: boolean;
  collapseConsecutiveCalls?: boolean;
};

export const ToolCallGroup = memo(
  ({
    entries,
    variant = 'default',
    isStreaming = false,
    collapseConsecutiveCalls = true,
  }: ToolCallGroupProps) => {
    if (variant === 'inline') {
      return (
        <InlineToolGroup
          entries={entries}
          isStreaming={isStreaming}
          collapseConsecutiveCalls={collapseConsecutiveCalls}
        />
      );
    }

    return <DefaultToolCallGroup entries={entries} isStreaming={isStreaming} />;
  },
);
ToolCallGroup.displayName = 'ToolCallGroup';
